import whenDomReady from 'when-dom-ready';
function initialise() {
    const shareBtn = document.querySelector('.js-share-btn');
    const shareContainer = document.querySelector('.js-share-container');
    shareBtn.addEventListener('click', (event) => {
        event.preventDefault();
        // Set active state.
        shareContainer.classList.toggle('is-active');
    });
}
whenDomReady().then(initialise);
